import Document from '@tiptap/extension-document';
import History from '@tiptap/extension-history';
import Paragraph from '@tiptap/extension-paragraph';
import Placeholder from '@tiptap/extension-placeholder';
import Text from '@tiptap/extension-text';
import {TiptapConfig, TiptapPreset} from '../types';

export const plainTextPreset = (config: TiptapConfig): TiptapPreset => {
  return {
    extensions: [
      Document,
      Paragraph,
      Text,
      History,
      Placeholder.configure({
        placeholder: config?.placeholder || '...',
      }),
    ],
    format: 'plain',
    toolbar: false,
  };
};
